/**
 * Pixels from the bottom of a stage to the top of a dek or meta plate.
 * Narrow headlines pad with this plus `HUB_HED_DEK_GAP`, so the lockup
 * tracks the real copy instead of a guessed band.
 */

import { type RefObject, useLayoutEffect } from "react";

export function useStageBottomClearance(
  rootRef: RefObject<HTMLElement | null>,
  edgeRef: RefObject<HTMLElement | null>,
  cssVar: string,
  enabled: boolean,
): void {
  useLayoutEffect(() => {
    const root = rootRef.current;
    const edge = edgeRef.current;
    if (!enabled || !root || !edge) {
      return;
    }
    const apply = () => {
      const clear =
        root.getBoundingClientRect().bottom - edge.getBoundingClientRect().top;
      root.style.setProperty(cssVar, `${Math.max(0, Math.round(clear))}px`);
    };
    apply();
    const observer = new ResizeObserver(apply);
    observer.observe(root);
    observer.observe(edge);
    return () => {
      observer.disconnect();
      root.style.removeProperty(cssVar);
    };
  }, [cssVar, edgeRef, enabled, rootRef]);
}
